import { Avatar, Typography } from "@mui/material";

import PaperFragment from "../misc/PaperFragment";

/**
 * A universal form component.
 * Includes icon, title, subtitle, and the actual form.
 *
 * Required props:
 * title
 * subtitle
 * icon
 * form
 *
 * Optional props:
 * show (boolean)
 */
export default function CustomForm(props) {
    const title = props.title;
    const subtitle = props.subtitle;
    const icon = props.icon;
    const form = props.form;

    const elevation = props.elevation;
    const show = props?.show ?? true;

    const p = props?.p;
    const m = props?.m;

    return (
        show && (
            <PaperFragment
                p={p}
                m={m}
                center
                elevation={elevation}
                value={
                    <>
                        {icon && <Avatar>{icon}</Avatar>}

                        <Typography component="h1" variant="h5" sx={{ pb: 1 }}>
                            {title}
                        </Typography>

                        <Typography component="p" variant="subtitle2" style={{ whiteSpace: "pre-line", paddingBottom: 1 }}>
                            {subtitle}
                        </Typography>

                        {form}
                    </>
                }
            />
        )
    );
}
